// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".bx--dropdown[data-v-ee8078c6]{border-bottom:none}.cv-header.bx--header[data-v-ee8078c6]{z-index:1;background-color:#fff;border-bottom:1px solid #e0e0e0;height:48px}.cv-header.bx--header .bx--btn--ghost[data-v-ee8078c6]{color:#525252;height:48px}.cv-header-name.bx--header__name[data-v-ee8078c6]{color:#525252;font-weight:400;font-size:14px}.cv-header-name.bx--header__name[data-v-ee8078c6]:hover{color:#181818}", ""]);
// Exports
module.exports = exports;
